import classnames from 'classnames'
import React, { useState } from 'react'

import RichText from '@src/quince-site-common/src/domains/RichText'

import { RichText as RichTextC, RichTextProps } from '../../molecules'

import styles from './accordianItem.module.scss'
import ChevronDown from './icons/chevronDown.inline.svg'

export interface AccordianItemProps {
  initialState?: boolean
  header: RichText | undefined
  body: RichText | undefined
  className?: string
  onClick?: () => void
  key?: string | number
}

const AccordianItem = ({ initialState, header, body, className, onClick }: AccordianItemProps) => {
  const [show, setShow] = useState(initialState)

  const handleClick: React.MouseEventHandler<HTMLElement> = e => {
    e.preventDefault()
    setShow(prevState => !prevState)
    if (onClick) onClick()
  }

  const headerRichTextProps: RichTextProps | undefined = RichText.makeRichTextProps(header)
  const bodyRichTextProps: RichTextProps | undefined = RichText.makeRichTextProps(body)

  return (
    <details className={classnames(styles.wrapper, className)} open={show}>
      <summary className={styles.wrapper__header} onClick={handleClick}>
        <div className={styles.wrapper__header__text}>
          {header && headerRichTextProps && <RichTextC {...headerRichTextProps} />}
        </div>
        <div className={styles.wrapper__header__sign}>
          <ChevronDown className={show ? styles.wrapper__header__sign__rotate : ''} />
        </div>
      </summary>
      <div className={styles.wrapper__body}>{body && bodyRichTextProps && <RichTextC {...bodyRichTextProps} />}</div>
    </details>
  )
}
export default AccordianItem
